import { CRMChannel, WhatsappMessageType } from "@jugl-web/rest-api";
import { TicketInboxFilter } from "@jugl-web/rest-api/tickets/models/common-types/TicketInboxFilter";
import { cx } from "@jugl-web/utils";
import { ClientSupportChannelView, ClientSupportTicketsView } from "./types";

export const collapsedIconButtonClassName = cx(
  "flex shrink-0 items-center justify-center rounded-lg border border-solid border-grey-300 bg-white shadow-none outline-none transition-shadow hover:shadow-[inset_0_0_0_1px_#DEDEE4] focus-visible:shadow-[inset_0_0_0_1px_#DEDEE4]"
);

export const DEFAULT_CHANNEL_VIEW: ClientSupportChannelView = {
  kind: "channel",
  channel: CRMChannel.whatsapp,
};

export const DEFAULT_TICKETS_VIEW: ClientSupportTicketsView = {
  kind: "tickets",
  filter: "all",
};

export const SUPPORTED_WHATSAPP_PAYLOAD_TYPES = [
  WhatsappMessageType.audio,
  WhatsappMessageType.document,
  WhatsappMessageType.video,
  WhatsappMessageType.image,
  WhatsappMessageType.text,
  WhatsappMessageType.sticker,
];

export const TICKET_INBOX_FILTER_TO_LABEL: Record<TicketInboxFilter, string> = {
  all: "All",
  assigned_to_user: "Assigned to me",
  unassigned: "Unassigned",
  in_progress: "In Progress",
  on_customer: "On Customer",
  on_hold: "On Hold",
  issued: "Issued",
  resolved: "Resolved",
};
